export default {
  "title": "FreeDive Ai",
  "heroHeadline": "Allenati ogni giorno e migliora le tue abilità di apnea!",
  "heroSubheadline": "L'app di allenamento in apnea con intelligenza artificiale definitiva per apneisti, pescatori in apnea e sirene.",
  "featuresHeader": "Perché scegliere FreeDive Ai?",
  "featuresSubtitle": "Tutto ciò di cui hai bisogno per immergerti più a fondo, trattenere il respiro più a lungo e rimanere al sicuro.",
  "feature1Title": "Allenamento Apnea con IA",
  "feature1Desc": "Tabelle personalizzate di CO2 e O2 generate dall'IA in base ai tuoi record personali per aumentare in modo sicuro i tempi di apnea.",
  "feature2Title": "Logbook Intelligente",
  "feature2Desc": "Registra le tue sessioni di apnea e pesca in apnea. Tieni traccia di profondità, tempi, frequenza cardiaca e SpO2 in un unico posto.",
  "feature3Title": "Competizioni e Licenze",
  "feature3Desc": "Tieni traccia delle tue licenze di apnea e rimani aggiornato su competizioni ed eventi globali.",
  "screenshotsTitle": "Screenshot dell'app",
  "copyright": "© DomiLabs. All rights reserved."
};
